import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import {
  SUCCESS_COOKIE_NAME,
  LOCKED_CONTENT_SOURCE,
  checkAuthStartSource,
} from 'helpers/AuthHelper';
import { getCommonTealiumProps } from 'helpers/AccountHelper';
import {
  BUILD_VERSION,
  callTealiumEvent,
  getTealiumSourceAuth,
  setSegmentPageStartSource,
  setTealiumProfileId,
  TEALIUM_EVENT_PREFIX,
  TealiumOnboardingActions,
} from '@foxcorp/delta-web-analytics';
import Style from './Provider.module.scss';

const Provider = (props = {}) => {
  const {
    '@id': providerId,
    adobePassId,
    isLive,
    name,
    onProviderClick,
    previewPassExpired,
    previewPassSignIn,
    profileId,
    selectedChannel,
  } = props;
  if (!name) return null;

  return (
    <div className={Style.providerContainer} key={`provider-${providerId}`}>
      <Link
        className={Style.provider}
        onClick={() => {
          const channel = isLive && selectedChannel ? selectedChannel : null;
          const id = adobePassId;
          const cookie = {
            name: SUCCESS_COOKIE_NAME,
            value: {
              selectedChannel: channel,
              provider: id,
            },
            options: {
              path: '/',
            },
          };
          onProviderClick(id, cookie);
          const action = 'authentication_select_provider';
          const authStartSource = getTealiumSourceAuth() || LOCKED_CONTENT_SOURCE;
          const onboardSrc = checkAuthStartSource(previewPassSignIn, previewPassExpired);
          const onboardingStartSource = onboardSrc;
          setSegmentPageStartSource({ previewPassSignIn, previewPassExpired });
          const data = setTealiumProfileId(profileId, {
            action,
            auth_start_source: authStartSource,
            dcg_profile_id: profileId,
            mvpd_select_type: 'other mvpd',
            mvpd: id,
            onboarding_action: TealiumOnboardingActions.COMPLETE,
            onboarding_start_source: onboardingStartSource,
            platform_version: BUILD_VERSION,
            profile_start_source: undefined,
            ...getCommonTealiumProps(),
          });
          callTealiumEvent(`${TEALIUM_EVENT_PREFIX}${action}`, data);
        }}
      >
        {name}
      </Link>
    </div>
  );
};

Provider.propTypes = {
  '@id': PropTypes.string,
  adobePassId: PropTypes.string,
  isLive: PropTypes.bool,
  name: PropTypes.string,
  onProviderClick: PropTypes.func,
  previewPassExpired: PropTypes.bool,
  previewPassSignIn: PropTypes.bool,
  profileId: PropTypes.string,
  selectedChannel: PropTypes.number,
};
Provider.defaultProps = {
  isLive: null,
  '@id': null,
  adobePassId: null,
  name: null,
  onProviderClick: () => {},
  previewPassExpired: null,
  previewPassSignIn: false,
  selectedChannel: null,
  profileId: null,
};

export default Provider;
